import { Card } from "design-system/molecules/Card"
import {
  ComparisonActivityChart,
  ComparisonChartConfig,
} from "design-system/organisms/insights/ComparisonActivityChart"
import { useTranslation } from "react-i18next"
import { GetSupportActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Props = {
  data: z.infer<typeof GetSupportActivityResponseDataSchema> | undefined
  isPending: boolean
}

export function BackofficeSupportActivity({ data, isPending }: Props) {
  const { t } = useTranslation()
  const chartConfig = {
    questions: {
      label: t("dashboard.activity.questions"),
      color: "var(--support-secondary)",
      type: "bar",
    },
    solved: {
      label: t("dashboard.activity.solved"),
      color: "var(--support-primary)",
      type: "bar",
    },
    solveRate: {
      label: t("dashboard.support.solveRate"),
      color: "var(--chart-2)",
      type: "line",
    },
  } satisfies ComparisonChartConfig
  const chartData = data?.dailyCount.every(({ baseValue }) => baseValue === 0)
    ? []
    : data?.dailyCount.map((day) => ({
        date: day.date,
        questions: day.baseValue,
        solved: day.topValue,
        solveRate: day.baseValue ? Math.round((day.topValue / day.baseValue) * 100) : undefined,
      }))

  return (
    <Card className="p-4">
      <ComparisonActivityChart
        data={chartData}
        chartConfig={chartConfig}
        chartClassName="h-[140px]"
        isPending={isPending}
        noDataT={{
          title: t("dashboard.activity.noData.title"),
          description: t("dashboard.activity.noData.description"),
        }}
      />
    </Card>
  )
}
